import type { TreeMapFilterCardProps } from "./tree-map-filter-card.type";

import { useTreeMap } from "../tree-map.context";
import { getFilterActiveNodesCount } from "../tree-map.helper";

import {
  getTreeMapFilterCardTitleType,
  hideTreeFilterCardSubFilters,
  showTreeMapFilterCardArrow,
} from "./tree-map-filter-card.helper";

export const useTreeMapFilterCard = ({
  type,
  subFilters,
}: TreeMapFilterCardProps) => {
  const {
    nodesByType,
    filterByType,
    toggleFilterByType,
    activateSubFilter,
    resetSubFilter,
    stats,
  } = useTreeMap();

  const checked = filterByType[type] ?? false;

  const count = getFilterActiveNodesCount(type, nodesByType);

  const titleType = getTreeMapFilterCardTitleType(type, stats);
  const hideSubFilters = hideTreeFilterCardSubFilters(type, stats);
  const showArrow = showTreeMapFilterCardArrow(type, stats);
  const showCount = type !== "location";

  const onToggle = (isChecked: boolean) => {
    toggleFilterByType(type);
    if (isChecked) resetSubFilters();
    else if (type === "location") activateLocationSubFilters();
  };

  const resetSubFilters = () => {
    if (type === "location") {
      resetSubFilter("location");
    }

    if (type === "asset") {
      resetSubFilter("conditionRating");
      resetSubFilter("state");
      resetSubFilter("assetType");
    }
  };

  const activateLocationSubFilters = () => {
    activateSubFilter({ type: "location", key: "position" });
    activateSubFilter({ type: "location", key: "perimeter" });
    activateSubFilter({ type: "location", key: "area" });
  };

  return {
    type,
    titleType,
    checked,
    count: showCount ? count : undefined,
    onToggle,
    showArrow,
    hideSubFilters,
    subFilters: hideSubFilters ? null : subFilters,
  };
};
